// Desk Line Supply - Premium Office Supplies & Workspace Essentials
// Brand operator: ARIO Technologies LLC
// Catalog & product copy sourced from theonlinemarketoffice.com

// ============================================
// SITE IMAGES - Office / workspace theme (stored locally, brand-free stock)
// ============================================
export const siteImages = {
  heroMain: '/banners/hero.jpg',
  heroSecondary: '/banners/promo.jpg',
  heroLifestyle: '/banners/about.jpg',
  ctaBackground: '/banners/cta.jpg',
  featuredBackground: '/banners/cta.jpg',
  powerBackground: '/banners/promo.jpg',
  shopBanner: '/banners/shop.jpg',
  aboutBanner: '/banners/about.jpg',
  contactBanner: '/banners/contact.jpg',
  returnsBanner: '/banners/shop.jpg',
  privacyBanner: '/banners/about.jpg',
};

export const SHIPPING_NOTICE = 'Free USPS shipping across the United States';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8555946804desklinesupply';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(855) 594-6804',
  email: 'contactus@desklinesupply.com',
  corpName: 'ARIO Technologies LLC',
  address: {
    street: '201 Val Verde Dr',
    city: 'Hemet',
    state: 'CA',
    zip: '92543',
    country: 'United States'
  }
};

// Return address must remain unchanged.
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// OFFICE SUPPLIES CATALOG (14 Products)
// Prices fixed to required processor MID points:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// Product names, images and descriptions sourced from theonlinemarketoffice.com
// ============================================
export const products = [
  // ===== DESK ORGANIZATION =====
  {
    id: "desk-organizer-tray",
    name: "Desk Organizer Tray",
    slug: "desk-organizer-tray",
    sku: "ONS-ORG-001",
    price: 9.63,
    image: "/products/office/desk-organizer-tray.jpg",
    badge: "Deal",
    categoryId: "desk-organization",
    categorySlug: "desk-organization",
    description: "A desk organizer tray is an essential office accessory designed to keep small desk items neat and always within reach. Multiple shaped compartments corral pens, paper clips, sticky notes and USB drives so your workspace stays tidy and every tool has a dedicated home.",
    keyBenefits: ["Multiple compartments for small items", "Keeps your desk clutter-free", "Compact footprint fits any desk"],
    usage: "Set it on your desk, sort your everyday supplies into the compartments and keep essentials at your fingertips.",
    features: ["Multi-Compartment", "Compact", "Durable", "Non-Slip Base"],
    inStock: true
  },
  {
    id: "staplers-set",
    name: "Classic Office Staplers Set",
    slug: "classic-office-staplers-set",
    sku: "ONS-ORG-002",
    price: 19.37,
    image: "/products/office/staplers-set.jpg",
    badge: "Best Value",
    categoryId: "desk-organization",
    categorySlug: "desk-organization",
    description: "Upgrade your office supplies with our Classic Office Staplers Set. This set includes durable, jam-resistant staplers built for everyday use, delivering crisp, reliable staples for reports, invoices and stacks of paperwork.",
    keyBenefits: ["Jam-resistant, reliable mechanism", "Comfortable full-strip capacity", "Built for heavy daily use"],
    usage: "Load a full strip of staples, line up your pages and press for a clean, secure bind every time.",
    features: ["Jam-Resistant", "Full-Strip", "Metal Body", "Everyday Use"],
    inStock: true
  },
  {
    id: "multi-drawer-organizer",
    name: "Compact Multi-Drawer Desk Organizer",
    slug: "compact-multi-drawer-desk-organizer",
    sku: "ONS-ORG-003",
    price: 28.89,
    image: "/products/office/multi-drawer-organizer.jpg",
    badge: "Popular",
    categoryId: "desk-organization",
    categorySlug: "desk-organization",
    description: "Organize your workspace efficiently with our Compact Multi-Drawer Desk Organizer. Stackable, smooth-gliding drawers sort stationery, documents and accessories so everything you need stays labeled, protected and easy to find.",
    keyBenefits: ["Multiple smooth-gliding drawers", "Sorts stationery and documents", "Space-saving stackable design"],
    usage: "Place it on your desk or shelf, assign each drawer a category and slide it open whenever you need a supply.",
    features: ["Multi-Drawer", "Stackable", "Space-Saving", "Clear Fronts"],
    inStock: true
  },

  // ===== WRITING & STATIONERY =====
  {
    id: "gel-pen-set",
    name: "Premium Gel Pen Set",
    slug: "premium-gel-pen-set",
    sku: "ONS-WRT-001",
    price: 12.84,
    image: "/products/office/gel-pen-set.jpg",
    badge: "Best Seller",
    categoryId: "writing-stationery",
    categorySlug: "writing-stationery",
    description: "A set of gel pens including vibrant, smooth-writing pens that deliver rich, quick-drying ink for effortless note-taking, journaling and everyday writing. Comfortable barrels reduce hand fatigue during long sessions at the desk.",
    keyBenefits: ["Smooth, quick-drying gel ink", "Vibrant assorted colors", "Comfort-grip barrels"],
    usage: "Uncap a pen, glide it across the page and let the fast-drying ink keep your notes crisp and smudge-free.",
    features: ["Gel Ink", "Assorted Colors", "Comfort Grip", "Quick-Dry"],
    inStock: true
  },
  {
    id: "fountain-pen",
    name: "Executive Fountain Pen Collection",
    slug: "executive-fountain-pen-collection",
    sku: "ONS-WRT-002",
    price: 19.26,
    image: "/products/office/fountain-pen.jpg",
    badge: "Premium",
    categoryId: "writing-stationery",
    categorySlug: "writing-stationery",
    description: "An elegant three-pen fountain writing set with refillable cartridges, featuring lacquered barrels and polished metal accents. A refined, gift-ready collection that brings a touch of ceremony to signatures, correspondence and journaling.",
    keyBenefits: ["Three refillable fountain pens", "Lacquered barrels, polished accents", "Gift-ready presentation"],
    usage: "Insert a cartridge, prime the nib and enjoy smooth, expressive ink flow for your most important writing.",
    features: ["Refillable", "Lacquered Finish", "Gift Set", "Smooth Nib"],
    inStock: true
  },

  // ===== OFFICE ELECTRONICS =====
  {
    id: "wireless-mouse",
    name: "Wireless Mouse",
    slug: "wireless-mouse",
    sku: "ONS-ELC-001",
    price: 58.11,
    image: "/products/office/wireless-mouse.jpg",
    badge: "Popular",
    categoryId: "office-electronics",
    categorySlug: "office-electronics",
    description: "A wireless mouse is a convenient and portable input device that eliminates cable clutter with a reliable 2.4GHz connection. Ergonomic contours and precise optical tracking make it comfortable and responsive for all-day productivity.",
    keyBenefits: ["Cable-free 2.4GHz connection", "Ergonomic, all-day comfort", "Precise optical tracking"],
    usage: "Plug in the nano receiver, switch the mouse on and start navigating instantly \u2014 no software required.",
    features: ["Wireless", "Ergonomic", "Optical", "Plug & Play"],
    inStock: true
  },
  {
    id: "streaming-webcam",
    name: "High-Definition Streaming Webcam",
    slug: "high-definition-streaming-webcam",
    sku: "ONS-ELC-002",
    price: 77.48,
    image: "/products/office/streaming-webcam.jpg",
    badge: "New",
    categoryId: "office-electronics",
    categorySlug: "office-electronics",
    description: "Look sharp on every video call with this full HD webcam engineered for clarity in any lighting. A wide-angle lens, built-in microphone and universal clip mount make it truly plug-and-play for meetings, streaming and remote work.",
    keyBenefits: ["Crisp full HD video", "Built-in noise-reducing mic", "Universal clip-on mount"],
    usage: "Clip it to your monitor or laptop, connect the USB cable and you are ready for your next call in seconds.",
    features: ["Full HD", "Wide-Angle", "Built-In Mic", "Plug & Play"],
    inStock: true
  },
  {
    id: "paper-shredder",
    name: "Compact Paper Shredder",
    slug: "compact-paper-shredder",
    sku: "ONS-ELC-003",
    price: 142.16,
    image: "/products/office/paper-shredder.jpg",
    badge: "Pro Pick",
    categoryId: "office-electronics",
    categorySlug: "office-electronics",
    description: "A compact paper shredder is a practical office device designed for securely disposing of sensitive documents. Cross-cut blades turn confidential paperwork into confetti-sized pieces, protecting your privacy right at your desk.",
    keyBenefits: ["Secure cross-cut shredding", "Compact desk-side footprint", "Pull-out waste bin for easy emptying"],
    usage: "Feed documents into the slot, let the cross-cut blades do the work and empty the bin when it fills.",
    features: ["Cross-Cut", "Compact", "Auto Feed", "Pull-Out Bin"],
    inStock: true
  },
  {
    id: "3d-printer",
    name: "Precision 3D Printer",
    slug: "precision-3d-printer",
    sku: "ONS-ELC-004",
    price: 999.00,
    image: "/products/office/3d-printer.jpg",
    badge: "Flagship",
    categoryId: "office-electronics",
    categorySlug: "office-electronics",
    description: "The V2 Precision 3D Printer is the ideal choice for both novices and experienced makers. A sturdy frame, heated bed and fine-layer resolution produce clean, detailed prints for prototypes, models and creative office projects.",
    keyBenefits: ["Fine-layer print resolution", "Heated, warp-resistant bed", "Beginner-friendly setup"],
    usage: "Load your filament, send a model from the slicer software and watch precise layers build your design.",
    features: ["High Resolution", "Heated Bed", "Sturdy Frame", "Easy Setup"],
    inStock: true
  },

  // ===== OFFICE FURNITURE =====
  {
    id: "file-cabinet",
    name: "Versatile Mobile Office File Cabinet",
    slug: "versatile-mobile-office-file-cabinet",
    sku: "ONS-FUR-001",
    price: 227.48,
    image: "/products/office/file-cabinet.jpg",
    badge: "Best Value",
    categoryId: "office-furniture",
    categorySlug: "office-furniture",
    description: "Optimize your office organization with our Versatile Mobile Office File Cabinet. Smooth-rolling casters and lockable drawers keep files secure and mobile, sliding neatly under most desks when they are not in use.",
    keyBenefits: ["Lockable drawers for security", "Smooth-rolling mobile casters", "Fits neatly under most desks"],
    usage: "Roll it beside or under your desk, file your folders in the drawers and lock up sensitive documents.",
    features: ["Lockable", "Mobile Casters", "Under-Desk", "Multi-Drawer"],
    inStock: true
  },
  {
    id: "office-chair",
    name: "Office Chair with Lumbar Support",
    slug: "office-chair-with-lumbar-support",
    sku: "ONS-FUR-002",
    price: 489.36,
    image: "/products/office/office-chair.jpg",
    badge: "Editor's Choice",
    categoryId: "office-furniture",
    categorySlug: "office-furniture",
    description: "Elevate your workspace comfort with our Ergonomic Mesh Office Chair, designed for all-day support. Adjustable lumbar, breathable mesh and a smooth-tilt mechanism keep you comfortable and productive from the first meeting to the last.",
    keyBenefits: ["Adjustable lumbar support", "Breathable mesh back", "Smooth-tilt recline mechanism"],
    usage: "Adjust the height and lumbar to your body, then lean back and let the mesh support you all day.",
    features: ["Lumbar Support", "Breathable Mesh", "Tilt Mechanism", "Height Adjust"],
    inStock: true
  },
  {
    id: "executive-chair",
    name: "Executive Leather Desk Chair",
    slug: "executive-leather-desk-chair",
    sku: "ONS-FUR-003",
    price: 784.88,
    image: "/products/office/executive-chair.jpg",
    badge: "Premium",
    categoryId: "office-furniture",
    categorySlug: "office-furniture",
    description: "An executive leather desk chair combines style, comfort and durability, making it the centerpiece of any professional office. Cushioned padding, a supportive high back and smooth recline deliver a premium seating experience.",
    keyBenefits: ["Premium cushioned leather", "Supportive high back", "Smooth, quiet recline"],
    usage: "Settle into the padded seat, recline to your preferred angle and work in executive comfort.",
    features: ["Leather", "High Back", "Padded", "Recline"],
    inStock: true
  },

  // ===== DECOR & AMBIANCE =====
  {
    id: "wall-art",
    name: "Contemporary Office Wall Art Collection",
    slug: "contemporary-office-wall-art-collection",
    sku: "ONS-DEC-001",
    price: 318.72,
    image: "/products/office/wall-art.jpg",
    badge: "New",
    categoryId: "decor-ambiance",
    categorySlug: "decor-ambiance",
    description: "Elevate your workspace aesthetic with this curated set of modern art prints designed to inspire focus and creativity. Ready to hang, the collection brings warmth, personality and a polished finish to any office wall.",
    keyBenefits: ["Curated modern print set", "Ready-to-hang framing", "Inspires focus and creativity"],
    usage: "Choose your wall, arrange the framed prints in a gallery layout and hang for an instant refresh.",
    features: ["Framed Set", "Modern Prints", "Ready to Hang", "Curated"],
    inStock: true
  },
  {
    id: "wall-clock",
    name: "Classic Analog Office Wall Clock",
    slug: "classic-analog-office-wall-clock",
    sku: "ONS-DEC-002",
    price: 612.44,
    image: "/products/office/wall-clock.jpg",
    badge: "Best Seller",
    categoryId: "decor-ambiance",
    categorySlug: "decor-ambiance",
    description: "Our Classic Analog Office Wall Clock is the perfect addition to any office, classroom or reception area. A clean, easy-to-read dial and silent sweep movement keep time reliably without the distraction of ticking.",
    keyBenefits: ["Clean, easy-to-read dial", "Silent sweep movement", "Suits any professional space"],
    usage: "Hang it on a central wall, insert a battery and enjoy accurate, whisper-quiet timekeeping.",
    features: ["Silent Sweep", "Easy-Read Dial", "Battery Powered", "Classic"],
    inStock: true
  },
];

export const categories = [
  {
    id: "desk-organization",
    name: "Desk Organization",
    slug: "desk-organization",
    description: "Trays, drawers and staplers that keep every desk tidy and productive",
    image: "/products/office/multi-drawer-organizer.jpg",
    productCount: 3
  },
  {
    id: "writing-stationery",
    name: "Writing & Stationery",
    slug: "writing-stationery",
    description: "Gel pens, fountain pens and refined tools for everyday writing",
    image: "/products/office/gel-pen-set.jpg",
    productCount: 2
  },
  {
    id: "office-electronics",
    name: "Office Electronics",
    slug: "office-electronics",
    description: "Mice, webcams, shredders and precision devices for the modern desk",
    image: "/products/office/wireless-mouse.jpg",
    productCount: 4
  },
  {
    id: "office-furniture",
    name: "Office Furniture",
    slug: "office-furniture",
    description: "Chairs and cabinets built for comfort, support and organization",
    image: "/products/office/office-chair.jpg",
    productCount: 3
  },
  {
    id: "decor-ambiance",
    name: "Decor & Ambiance",
    slug: "decor-ambiance",
    description: "Wall art and clocks that give your workspace warmth and character",
    image: "/products/office/wall-art.jpg",
    productCount: 2
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Curated Office Essentials', description: 'A focused, hand-picked lineup of supplies worth putting on your desk \u2014 no filler' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order, no minimum required' },
  { id: 3, title: '30-Day Returns', description: 'Changed your mind? Send it back within 30 days, hassle-free' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and privacy-first handling of your details' }
];

export const performanceBenefits = [
  { id: 1, title: 'Built for Work', description: 'Every item is chosen for real-world durability and daily reliability' },
  { id: 2, title: 'Detail Obsessed', description: 'Clean finishes, dependable mechanisms and quality materials throughout' },
  { id: 3, title: 'Workspace Approved', description: 'Supplies that keep home offices, studios and teams running smoothly' },
  { id: 4, title: 'Fair, Honest Pricing', description: 'Straightforward prices on the office supplies you actually need' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated collection of office supplies and workspace essentials.' },
  { id: 2, title: 'Choose', description: 'Pick the desk, writing, electronics or furniture pieces that fit your setup.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with fast, secure and encrypted payment.' },
  { id: 4, title: 'Get to Work', description: 'Unbox, set up and enjoy a more organized, productive workspace.' }
];
